(() => {
  const DEFAULT_SUMMARY_COPY = {
    firm: 'Ưu tiên bề mặt nâng đỡ chắc chắn để giữ cột sống ổn định và hạn chế cảm giác lún.',
    contour: 'Ưu tiên độ êm ôm vừa phải để giảm áp lực lên vai và hông khi nghỉ ngơi.',
    bouncy: 'Ưu tiên độ đàn hồi và khả năng trở mình linh hoạt cho cảm giác nâng đỡ thoải mái.',
    cooling: 'Ưu tiên bề mặt thoáng mát và hỗ trợ giảm tích nhiệt khi ngủ.'
  };

  class MattressFinder {
    constructor(root) {
      if (root.dataset.mfReady === 'true') return;

      this.root = root;
      this.modal = root.querySelector('[data-mf-modal]');
      this.dialog = root.querySelector('[data-mf-dialog]');
      this.quizPanel = root.querySelector('[data-mf-quiz-panel]');
      this.resultPanel = root.querySelector('[data-mf-result-panel]');
      this.steps = Array.from(root.querySelectorAll('[data-mf-step]'));
      this.progress = root.querySelector('[data-mf-progress]');
      this.nextButton = root.querySelector('[data-mf-next]');
      this.summary = root.querySelector('[data-mf-summary]');
      this.recommendations = Array.from(root.querySelectorAll('[data-mf-recommendation]'));
      this.nextLabel = root.dataset.mfNextLabel || 'Tiếp tục';
      this.resultsLabel = root.dataset.mfResultsLabel || 'Xem kết quả';
      this.summaryCopy = {
        firm: root.dataset.mfSummaryFirm || DEFAULT_SUMMARY_COPY.firm,
        contour: root.dataset.mfSummaryContour || DEFAULT_SUMMARY_COPY.contour,
        bouncy: root.dataset.mfSummaryBouncy || DEFAULT_SUMMARY_COPY.bouncy,
        cooling: root.dataset.mfSummaryCooling || DEFAULT_SUMMARY_COPY.cooling
      };
      this.selections = [];
      this.currentStep = 0;
      this.lastFocusedElement = null;

      root.querySelectorAll('[data-mf-open]').forEach((button) => {
        button.addEventListener('click', () => this.open());
      });
      root.querySelectorAll('[data-mf-close]').forEach((button) => {
        button.addEventListener('click', () => this.close());
      });
      root.querySelectorAll('[data-mf-restart]').forEach((button) => {
        button.addEventListener('click', () => this.restart());
      });
      root.querySelectorAll('[data-mf-answer]').forEach((button) => {
        button.setAttribute('aria-pressed', 'false');
        button.addEventListener('click', () => this.selectAnswer(button));
      });
      this.nextButton.addEventListener('click', () => this.advance());
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !this.modal.hidden) this.close();
      });

      root.dataset.mfReady = 'true';
      if (this.steps.length) this.showStep(0);
    }

    open() {
      this.lastFocusedElement = document.activeElement;
      this.modal.hidden = false;
      document.body.classList.add('mf-modal-open');
      this.dialog.scrollTop = 0;
      this.modal.querySelector('[data-mf-close]').focus();
    }

    close() {
      this.modal.hidden = true;
      document.body.classList.remove('mf-modal-open');
      if (this.lastFocusedElement) this.lastFocusedElement.focus();
    }

    restart() {
      this.selections = [];
      this.root.querySelectorAll('[data-mf-answer]').forEach((button) => {
        button.classList.remove('is-selected');
        button.setAttribute('aria-pressed', 'false');
      });
      this.quizPanel.hidden = false;
      this.resultPanel.hidden = true;
      this.showStep(0);
      this.dialog.scrollTop = 0;
    }

    selectAnswer(button) {
      const step = button.closest('[data-mf-step]');
      step.querySelectorAll('[data-mf-answer]').forEach((option) => {
        option.classList.toggle('is-selected', option === button);
        option.setAttribute('aria-pressed', option === button ? 'true' : 'false');
      });
      this.selections[this.currentStep] = button.dataset.mfScore || '';
      this.nextButton.disabled = false;
    }

    advance() {
      if (!this.steps.length) return;
      if (!this.selections[this.currentStep]) return;

      if (this.currentStep < this.steps.length - 1) {
        this.showStep(this.currentStep + 1);
        return;
      }

      this.showResults();
    }

    showStep(index) {
      this.currentStep = index;
      this.steps.forEach((step, stepIndex) => {
        step.hidden = stepIndex !== index;
      });
      this.progress.style.width = `${((index + 1) / this.steps.length) * 100}%`;
      this.nextButton.textContent = index === this.steps.length - 1 ? this.resultsLabel : this.nextLabel;
      this.nextButton.disabled = !this.selections[index];
    }

    showResults() {
      const tally = {
        premium: 0,
        balanced: 0,
        value: 0,
        firm: 0,
        contour: 0,
        bouncy: 0,
        cooling: 0
      };

      this.selections.forEach((selection) => {
        selection.split(',').forEach((score) => {
          const [key, points] = score.split(':');
          if (Object.prototype.hasOwnProperty.call(tally, key)) {
            tally[key] += Number(points || 0);
          }
        });
      });

      const tier = this.topResult(tally, ['premium', 'balanced', 'value'], 'balanced');
      const feel = this.topResult(tally, ['firm', 'contour', 'bouncy', 'cooling'], 'contour');
      this.summary.textContent = this.summaryCopy[feel];

      const rankedRecommendations = this.recommendations
        .map((card) => {
          let score = Number(card.dataset.mfPriority || 0);
          if (card.dataset.mfTier === tier) score += 5;
          if (card.dataset.mfFeel === feel) score += 7;
          return { card, score };
        })
        .sort((a, b) => b.score - a.score);

      rankedRecommendations.forEach(({ card }, index) => {
        card.hidden = index > 2;
        card.style.order = index;
        card.classList.toggle('is-primary', index === 0);
        const rankLabel = card.querySelector('[data-mf-rank-label]');
        if (rankLabel) rankLabel.textContent = index === 0 ? 'Gợi ý phù hợp nhất' : 'Lựa chọn tham khảo';
      });

      this.quizPanel.hidden = true;
      this.resultPanel.hidden = false;
      this.dialog.scrollTop = 0;
    }

    topResult(tally, keys, fallback) {
      return keys.reduce((winner, key) => tally[key] > tally[winner] ? key : winner, fallback);
    }
  }

  const init = (scope = document) => {
    scope.querySelectorAll('[data-mattress-finder]').forEach((root) => new MattressFinder(root));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
